<template>
  <q-page class="page">
    <div id="map" class="map"></div>  
  </q-page>
</template>
<script>
import { date } from 'quasar'
import axios from 'axios'
import qs from 'qs'
import Vue from 'vue'

import {eventBus} from '../main'

export default {
  name: 'PageGeoRegions',
  components: {
    
  },
  data: function () {
    return {
      map: null,
      mapType: 'roadmap',
      mapProvider: 'google',
      liveTrack_list: [],
      liveTrackPosition_list: [], 
      liveTrackPolyline_list: [],
      liveTrackPositionArrow_list: [],  
      positon_list: {},
      marker_list: {},
      form: {
        SessionId: null,
      },
      interval: null,
      alert_list: [],
      mapTypeId: 1,
    }
  },
  methods: {
    Map() {
      var self = this
      this.map = L.map('map').setView([this.$store.state.session.StartLatitude, 
        this.$store.state.session.StartLongitude], this.$store.state.session.StartZoomLevel)
        
      self.setMap(this.$store.state.session.MapTypeId)
      document.getElementsByClassName( 'leaflet-control-attribution' )[0].style.display = 'none'
      this.editableLayers = new L.FeatureGroup();
      this.map.addLayer(this.editableLayers);
      
    },
    fetchData (){
      var self = this
      this.interval = setInterval(() => {
        console.log('update devices: ' + this.liveTrack_list)
        eventBus.$emit('dataLoad')
        if(this.liveTrack_list.length != 0){
          this.form.SessionId = this.$store.state.session.SessionId
          this.form.action = "LastPositions"
          this.form.devlist = this.liveTrack_list
          axios.post(this.$apiUrl,
          qs.stringify(this.form),
          {
              headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
          })
          .then(response => {
              this.submitting = false
              if(response.status == 200){          
                response.data.forEach(position => {
                  var lastPosition = self.liveTrackPosition_list[position.DeviceID]
                  if(position.TrackingID > lastPosition.trackingId){ 
                    lastPosition.marker.removeFrom(self.map)
                    if(!this.$store.state.showTracks){ //Take off the arrows if live tracking without show track
                      if (self.liveTrackPositionArrow_list[position.DeviceID] != undefined){
                        self.liveTrackPositionArrow_list[position.DeviceID].forEach(function (arrow) {
                          if(arrow != undefined){
                            arrow.removeFrom(self.map) 
                          }
                        })
                      }
                    }
                    var marker = this.positionMarker(position, 1)
                    this.liveTrackPosition_list[position.DeviceID] = { marker: marker.marker, trackingId: position.TrackingID } 
                    this.liveTrackPositionArrow_list[position.DeviceID].push(marker.markerArrow) 

                    if(this.$store.state.showTracks){
                      var pointA = lastPosition.marker._latlng
                      var pointB = new L.LatLng(position.Latitude, position.Longitude);
                      var pointList = [pointA, pointB];
                      
                      var polyline = new L.Polyline(pointList, {
                          color: 'red',
                          weight: 3,
                          opacity: 0.5,
                          smoothFactor: 1
                      });
                      polyline.addTo(this.map);
                      this.liveTrackPolyline_list[position.DeviceID].push(polyline)
                    }

                  }
                })
              }
              else{
                  this.$q.notify('Something Wrong.')
              }
          })
          .catch(e => {
            this.$q.notify('Something Wrong.')
            console.log(e);
          })
        }
      }, 30000)
    },
    showLastPositions (devArray) {
      this.form.SessionId = this.$store.state.session.SessionId
      this.form.action = "LastPositions"
      this.form.devlist = devArray
      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
          this.submitting = false
          if(response.status == 200){ 
            var Lat = null
            var Lng = null
            response.data.forEach(position => {
              this.liveTrackPolyline_list[position.DeviceID] = []
              this.liveTrackPositionArrow_list[position.DeviceID] = []
              var marker = this.positionMarker(position, 1)
              this.liveTrackPosition_list[position.DeviceID] = { marker: marker.marker, trackingId: position.TrackingID } 
              this.liveTrackPositionArrow_list[position.DeviceID].push(marker.markerArrow) 
              Lat = position.Latitude
              Lng = position.Longitude
            })
            if(Lat != null){
              this.map.panTo([Lat, Lng])
            }
          }
          else{
              this.$q.notify('Something Wrong.')
          }
      })
      .catch(e => {
        this.$q.notify('Something Wrong.')
        console.log(e);
      })
    },
    formatSeconds(a) { 
        var hours=Math.floor(a/3600)
        var minutes=Math.floor(a/60)-(hours*60)
        var seconds=a-(hours*3600)-(minutes*60) 

        var hs=' ' + this.$t('global.Hour');var ms=' ' + this.$t('global.Minute');var ss=' '+ this.$t('global.Second'); 
        if (this.$i18n.locale == "de"){
            if (hours!=1) {hs+='n'} 
            if (minutes!=1) {ms+='n'} 
            if (seconds!=1) {ss+='n'}  
        }
        else{
            if (hours!=1) {hs+='s'} 
            if (minutes!=1) {ms+='s'} 
            if (seconds!=1) {ss+='s'} 
        }
        return hours+hs+', '+minutes+ms+', '+seconds+ss 
    },
    dateFormat(val) {
      if (this.$i18n.locale == "de")
        return this.moment(val).format('DD.MM.YYYY HH:mm:ss')
      else
        return this.moment(val).format('MM/DD/YYYY HH:mm:ss')
    }, 
    positionMarker(position, positionType){
      //positionType: 1=live, 2=history induvidual position, 3=history day or hour
      var color = 'red'
      var IgnitionStatus = this.$t('global.Off')
      if (position.IgnitionStatus){
        color = 'green'
        IgnitionStatus = this.$t('global.On')
      }
      if(position.IgnitionStatus && position.IdleTimeSecTotal > 0){
        color = 'orange'
      }
      var icon = 'car'
      if(position.IsPerson)
        icon = 'user'

      var html ='<div style="font-size:18px;">' + this.$t('global.Unit') + ':<b> ' 
      + position.DeviceName +  '</b><br>' + this.$t('global.DateTime') + ': <b>' 
      + this.dateFormat(position.PositionDateTime)
      + '</b><br>' + this.$t('global.Speed') + ':<b> ' + position.Speed + '</b> km/h<br>' + this.$t('global.Heading') + ':<b> ' 
      + position.Direction 
      + '</b> ' + this.$t('global.Degree') + '' 
      + '<br>' + this.$t('global.IgnitionStatus') + ':<b> ' + IgnitionStatus
      + '</b><br>ID:<b> ' + position.TrackingID + '</b>'
          
      if (position.IdleTimeSecTotal != 0)
      {
          html += "<br>" + this.$t('global.IdleTime') + ": " + this.formatSeconds(position.IdleTimeSecTotal)
      }                 
      if (position.StopTimeSec != 0)
      {
          html += "<br>" + this.$t('global.StopTime') + ": " + this.formatSeconds(position.StopTimeSec);
      }          
      if (position.BatteryPercent != 0)
      {
          html += "<br>Battery Status: " + position.BatteryPercent + " %";  
      }

      if (position.AlertID !== null)
      {
          html += "<br>Alert: <b>" + position.AlertConfigName + "</b>";  
      }

      html += '<br><a href="https://www.google.com/maps/search/?api=1&query=' + position.Latitude + ',' + position.Longitude + '" target="_blank">' + this.$t('global.Map') + '</a>'
      
      var marker = new L.Marker([position.Latitude, position.Longitude],  
      {icon: L.AwesomeMarkers.icon({icon: icon, prefix: 'fa', markerColor: color, spin:false }) }) 

      marker.bindPopup(html)
      marker.bindTooltip( position.DeviceName, {permanent: true, direction:"top", opacity: 0.7, offset: [0, -36]})
      
      if(positionType != 3){
        marker.addTo(this.map)
      }
      
      var dirRound = (Math.round(position.Direction / 10)) * 10;     
      
      var arrowIcon = L.icon({
        iconUrl: '/images/arrow/arrow' + dirRound + '.png',
        iconSize:     [36, 36], // size of the icon
        iconAnchor:   [18, 18], // point of the icon which will correspond to marker's location
        //popupAnchor:  [-3, -76] // point from which the popup should open relative to the iconAnchor
      })

      if(positionType == 1 || positionType == 3){
        //if(positionType != 1 || this.$store.state.showTracks){
          if(this.$store.state.showHeadings){
            var markerArrow = new L.marker([ position.Latitude, position.Longitude ], {icon: arrowIcon})
            markerArrow.bindPopup(html)  
            markerArrow.addTo(this.map)
          }
        //}
      }

      if(positionType == 3){   
        if (position.AlertID != null && this.$store.state.showAlerts)
        {
          var stopIcon = L.icon({ iconUrl: '/images/alert.png', iconAnchor: [16, 38] })
          marker = new L.Marker([position.Latitude, position.Longitude], {icon: stopIcon  })  
          marker.bindPopup(html)  
          marker.addTo(this.map)
        }
        else{ 
          if (position.StopTimeSec != 0 && this.$store.state.showStops)
          {
            var stopIcon = L.icon({ iconUrl: '/images/stop.png', iconAnchor: [16, 38] })
            marker = new L.Marker([position.Latitude, position.Longitude], {icon: stopIcon  })  
            marker.bindPopup(html)  
            marker.addTo(this.map)
          }
          else{
            if (position.IdleTimeSecTotal != 0 && this.$store.state.showIdles)
            {
              var idleIcon = L.icon({ iconUrl: '/images/stoplight.png', iconAnchor: [16, 38] })
              marker = new L.Marker([position.Latitude, position.Longitude], {icon: idleIcon  })  
              marker.bindPopup(html)  
              marker.addTo(this.map)
            }
          }
        }
      }

      return { marker: marker, markerArrow: markerArrow }
    },
    showHistoryPositions(positions, markerKey){
      var self = this
      var pointList = []
      self.marker_list[markerKey] = []
      var lastPoint = null
      positions.forEach(function (position) {
        var markers = self.positionMarker(position, 3)
        var arrow = markers.markerArrow
        var point = L.latLng(position.Latitude, position.Longitude);
        pointList.push(point)
        if(markers.markerArrow != undefined){
          self.marker_list[markerKey].push(markers.markerArrow)
        }
        self.marker_list[markerKey].push(markers.marker)
        lastPoint = point
      })
      var polyline = new L.Polyline(pointList, {
          color: 'red',
          weight: 2,
          opacity: 0.5,
          smoothFactor: 1
      })
      self.marker_list[markerKey].push(polyline)
      polyline.addTo(self.map)
      this.map.panTo(lastPoint)
    },

    setMap(data){
      this.mapTypeId = data
      if(data != 11){
        if(this.tileLayer != undefined){
          this.map.removeLayer(this.tileLayer) 
        }
      }
      
      var traffic = false
      
      if(data == 4){
        this.tileLayer = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
          maxZoom: 19,
          attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
        });
        this.tileLayer.addTo(this.map)
        return
      }

      if(data == 5){
        this.tileLayer = L.tileLayer(
          'https://cartodb-basemaps-{s}.global.ssl.fastly.net/rastertiles/voyager/{z}/{x}/{y}.png',
          {
            maxZoom: 18,
          }
        );
        this.tileLayer.addTo(this.map)
        return
      }

      if(data == 6){
          this.tileLayer = L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}', {
            attribution: 'Tiles &copy; Esri &mdash; Source: Esri, DeLorme, NAVTEQ, USGS, Intermap, iPC, NRCAN, Esri Japan, METI, Esri China (Hong Kong), Esri (Thailand), TomTom, 2012'
          });  
          this.tileLayer.addTo(this.map)
          return
      }


      if(data == 7){
        var accessToken = 'pk.eyJ1IjoibWFwYm94IiwiYSI6ImNpejh2N21nMzAxMmQzMnA5emRyN2lucW0ifQ.jSE-g2vsn48Ry928pqylcg' || 'pk.eyJ1IjoiZXhhbXBsZXMiLCJhIjoiY2p0MG01MXRqMW45cjQzb2R6b2ptc3J4MSJ9.zA2W0IkI0c6KaAhJfk9bWg';
        this.tileLayer = L.tileLayer('https://api.mapbox.com/styles/v1/mapbox/streets-v11/tiles/{z}/{x}/{y}?access_token=' + accessToken, {
              attribution: '© <a href="https://www.mapbox.com/feedback/">Mapbox</a> © <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
        })
        this.tileLayer.addTo(this.map)
        return
      }
      
      var bKey = 'AuhiCJHlGzhg93IqUH_oCpl_-ZUrIE6SPftlyGYUvr9Amx5nzA-WqGcPquyFZl4L'

      if(data == 9){
        this.tileLayer = L.tileLayer.bing({bingMapsKey: bKey, imagerySet: 'Road' })
        this.tileLayer.addTo(this.map)
        return
      }
      if(data == 8){
        this.tileLayer = L.tileLayer.bing({bingMapsKey: bKey, imagerySet: 'Aerial' })
        this.tileLayer.addTo(this.map)
        return
      }
      if(data == 10){
        this.tileLayer = L.tileLayer.bing({bingMapsKey: bKey, imagerySet: 'AerialWithLabels' })
        this.tileLayer.addTo(this.map)
        return
      }

      if(data == 11){

        this.tileLayer = L.tileLayer('https://tiles.openseamap.org/seamark/{z}/{x}/{y}.png', {
          attribution: 'Map data: &copy; <a href="http://www.openseamap.org">OpenSeaMap</a> contributors'
        });
        this.tileLayer.addTo(this.map)
        return
      }
      

      var mType = 'roadmap'
      //gmap's:
      if(data == 1){
        mType = 'roadmap'
        traffic = true       
      }
      if(data == 2){
        mType = 'roadmap'
        traffic = false       
      }
      if(data == 3){
        mType = 'satellite'
        traffic = false       
      }

      this.tileLayer = L.gridLayer.googleMutant({ type: mType })
      if(traffic){
        this.tileLayer.addGoogleLayer('TrafficLayer');
      }
      this.tileLayer.addTo(this.map) 
    }
  },
  created () {
    this.fetchData()
    eventBus.$on('login', (data) => {
      this.fetchData()
    }),


    eventBus.$on('logout', (data) => {
      clearInterval(this.interval)
    }),

    eventBus.$on('addLiveTrack', (devArray) => {
      var liveTrack_list = this.liveTrack_list
      devArray.forEach(function (dev) {
        liveTrack_list.push(dev)
      });
      this.showLastPositions(devArray)
    }),

    eventBus.$on('removeLiveTrack', (devArray) => {
      var self = this
      devArray.forEach(function (dev) {
        self.liveTrack_list = self.liveTrack_list.filter(item => item !== dev)
        if(self.liveTrackPosition_list[dev] != undefined){
          self.liveTrackPosition_list[dev].marker.removeFrom(self.map)
        }
        if (self.liveTrackPolyline_list[dev] != undefined){
           self.liveTrackPolyline_list[dev].forEach(function (polyline) {
             polyline.removeFrom(self.map) 
           })
        }
        if (self.liveTrackPositionArrow_list[dev] != undefined){
           self.liveTrackPositionArrow_list[dev].forEach(function (arrow) {
             if(arrow != undefined){
              arrow.removeFrom(self.map) 
             }
           })
        }
      })
    }),

    eventBus.$on('changeMapType', (data) => {
      this.setMap(data)
    }),
    eventBus.$on('showObject', (data) => {
      data.addTo(this.map)
    }),
    
    eventBus.$on('showCurrentGpsPosition', (data) => {
      if(this.currentGpsPositionMarker != null){
        this.currentGpsPositionMarker.removeFrom(this.map)
      }
      this.currentGpsPositionMarker = L.marker(data.latlong).addTo(this.map);
      this.currentGpsPositionMarker.bindPopup("<b>" + data.label + "</b>");
    }),
    
    eventBus.$on('saveMapSettings', (data) => {
      var zoom = this.map.getZoom()
      var center = this.map.getCenter() //lat lng
      
      this.form.SessionId = this.$store.state.session.SessionId
      this.form.action = "SaveMap"
      this.form.lat = center.lat
      this.form.lng = center.lng
      this.form.zoom = zoom
      
      this.form.mapTypeId = this.mapTypeId
      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
          this.submitting = false
          if(response.status == 200){ 
            if(response.data == "OK"){
                this.$q.notify({ message: this.$t("global.MapSaved"), type: 'positive' })
              }
              else{
                this.$q.notify('Something Wrong.')
              }   
          }
          else{
              this.$q.notify('Something Wrong.')
          }
      })
      .catch(e => {
        this.$q.notify('Something Wrong.')
        console.log(e);
      })
    }),
    eventBus.$on('showPosition', (trackingId) => {
      this.form.SessionId = this.$store.state.session.SessionId
      this.form.action = "Position"
      this.form.trackingId = trackingId
      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
          this.submitting = false
          if(response.status == 200){ 
            var marker = this.positionMarker(response.data, 2)
            this.positon_list[response.data.TrackingID] = marker.marker
            this.map.panTo([response.data.Latitude, response.data.Longitude])
          }
          else{
              this.$q.notify('Something Wrong.')
          }
      })
      .catch(e => {
        this.$q.notify('Something Wrong.')
        console.log(e);
      })
    }),
    eventBus.$on('removePosition', (trackingId) => {
      this.positon_list[trackingId].removeFrom(this.map) 
    }),
    eventBus.$on('showHour', (data) => {
      
      var day = data.day
      var hour = data.hour
      var devId = data.devId
      
      this.form.SessionId = this.$store.state.session.SessionId
      this.form.action = "PositionHour"
      this.form.Day = day
      this.form.Hour = hour
      this.form.DeviceID = devId
      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
          this.submitting = false
          if(response.status == 200){ 
            //second parameter as a key for the marker list
            this.showHistoryPositions(response.data, devId + '_' + day + '_' + hour )
          }
          else{
              this.$q.notify('Something Wrong.')
          }
      })
      .catch(e => {
        this.$q.notify('Something Wrong.')
        console.log(e);
      })
    }),
    eventBus.$on('removeHour', (data) => {
      var day = data.day
      var hour = data.hour
      var devId = data.devId
      var key = devId + '_' + day + '_' + hour
      
      var mapObjects = this.marker_list[key]
      var self = this
      mapObjects.forEach(function (obj) {
        obj.removeFrom(self.map)
      })           
    }),

    eventBus.$on('showDay', (data) => {
      var day = data.day
      var devId = data.devId
      
      this.form.SessionId = this.$store.state.session.SessionId
      this.form.action = "PositionDay"
      this.form.Day = day
      this.form.DeviceID = devId
      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
          this.submitting = false
          if(response.status == 200){ 
            this.$store.state.loading = false
            this.showHistoryPositions(response.data, devId + '_' + day)
          }
          else{
              this.$store.state.loading = false
              this.$q.notify('Something Wrong.')
          }
      })
      .catch(e => {
        this.$q.notify('Something Wrong.')
        this.$store.state.loading = false
        console.log(e);
      })
    }),

    eventBus.$on('removeDay', (data) => {
      var day = data.day
      var devId = data.devId
      var key = devId + '_' + day
      
      var mapObjects = this.marker_list[key]
      var self = this
      mapObjects.forEach(function (obj) {
        obj.removeFrom(self.map)
      })           
    })
    eventBus.$on('showAlert', (a) => { 
          
      var stopIcon = L.icon({ iconUrl: '/images/alert.png', iconAnchor: [16, 38] })
      var marker = new L.Marker([a.Latitude, a.Longitude], {icon: stopIcon  })  

      var IgnitionStatus = this.$t('global.Off')
      if (a.IgnitionStatus){
        IgnitionStatus = this.$t('global.On')
      }
      var html ='<div style="font-size:18px;">' + this.$t('global.Unit') + ':<b> ' 
      + a.DeviceName +  '</b><br>' + this.$t('global.DateTime') + ': <b>' 
      + this.dateFormat(a.AlertDateTime)
      + '</b><br>' + this.$t('global.Speed') + ':<b> ' + a.Speed + '</b> km/h<br>' + this.$t('global.Heading') + ':<b> ' 
      + a.Direction 
      + '</b> ' + this.$t('global.Degree') + '' 
      + '<br>' + this.$t('global.IgnitionStatus') + ':<b> ' + IgnitionStatus
      + '</b><br>ID:<b> ' + a.TrackingID + '</b>'


      marker.bindPopup(html)  
      marker.addTo(this.map)
      this.alert_list[a.AlertID] = marker
      this.map.panTo([a.Latitude, a.Longitude])
    }),
    eventBus.$on('removeAlert', (a) => {   
      this.alert_list[a.AlertID].removeFrom(this.map)
    })
  },
  mounted() {
    this.Map()   
  },
  beforeDestroy(){
    clearInterval(this.interval)
  }
}
function round(value, decimals) {
  return Number(Math.round(value+'e'+decimals)+'e-'+decimals);
}


</script>
<style scoped>
.map{
  padding: 20px;
  height: calc(100vh - 60px);
  width: 100%;
}
.page{
  padding: 5px;
}
</style>
